import httpClient from './httpClient'

const CampaignBudgetApi = {
  async getByCampaignId(campaignId) {
    try {
      const res = await httpClient.get(`/campaign/${campaignId}/budget`)
      return res.data
    } catch (e) {
      console.error(e)
      throw e
    }
  },
}

export default CampaignBudgetApi
